import * as auth from '@/api/auth'

function setAuth (dados) {
  dados.logado = true
  localStorage.setItem('auth', JSON.stringify(dados))
}

function getAuth () {
  return JSON.parse(localStorage.getItem('auth')) || false
}

function cleanAuth () {
  localStorage.removeItem('auth')
}

const state = {
  logado: false,
  usuario: {},
  confirmaSenha: {
    estado: false,
    acesso: { tela: null, funcionalidade: null },
    token: false,
    onConfirm: () => {},
    onClose: () => {}
  }
}

const getters = {
  funcionalidades: (state) => (param) => {
    if (state.usuario &&
        state.usuario.acesso &&
        state.usuario.acesso.funcionalidades &&
        state.usuario.acesso.funcionalidades[param]) return state.usuario.acesso.funcionalidades[param]
    return {}
  },
  telas: (state) => (param) => {
    if (state.usuario &&
        state.usuario.acesso &&
        state.usuario.acesso.telas &&
        state.usuario.acesso.telas[param]) return state.usuario.acesso.telas[param]
    return {}
  },
  token: (state) => (acesso) => {
    // Valida Tela
    if (acesso &&
        acesso.tela &&
        state.confirmaSenha.acesso.tela &&
        state.confirmaSenha.token &&
        state.confirmaSenha.acesso.tela === acesso.tela) {
      return state.confirmaSenha.token
    }
    // Valida Funcionalidade
    if (acesso &&
        acesso.funcionalidade &&
        state.confirmaSenha.acesso.funcionalidade &&
        state.confirmaSenha.token &&
        state.confirmaSenha.acesso.funcionalidade === acesso.funcionalidade) {
      return state.confirmaSenha.token
    }
    return (state.usuario && state.usuario.token) ? state.usuario.token : undefined
  },
  jaConfirmado: (state) => (acesso) => {
    // Valida Tela
    if (acesso &&
        acesso.tela &&
        state.confirmaSenha.acesso.tela &&
        state.confirmaSenha.acesso.tela === acesso.tela) {
      return true
    }
    // Valida Funcionalidade
    if (acesso &&
        acesso.funcionalidade &&
        state.confirmaSenha.acesso.funcionalidade &&
        state.confirmaSenha.acesso.funcionalidade === acesso.funcionalidade) {
      return true
    }
    return false
  },
  relatorios: (state) => {
    let relatorios = []
    if (state.usuario && state.usuario.acesso && state.usuario.acesso.relatorios && state.usuario.acesso.relatorios) {
      Object.keys(state.usuario.acesso.relatorios).forEach(indice => {
        let element = state.usuario.acesso.relatorios[indice]
        if (element.itens.length > 0) relatorios.push(element)
      })
    }
    return relatorios
  },
  relatoriosTela: (state) => (tela) => {
    let relatorios = []
    if (state.usuario && state.usuario.acesso && state.usuario.acesso.relatorios && state.usuario.acesso.relatorios[tela] && state.usuario.acesso.relatorios[tela].itens.length > 0) {
      relatorios = state.usuario.acesso.relatorios[tela].itens
    }
    return relatorios
  },
  impressaoTela: (state) => (tela) => {
    let impressao = false
    if (state.usuario && state.usuario.acesso && state.usuario.acesso.relatorios && state.usuario.acesso.relatorios[tela] && state.usuario.acesso.relatorios[tela].impressao) {
      impressao = state.usuario.acesso.relatorios[tela].impressao
    }
    return impressao
  }
}

const mutations = {
  SETAUTH (state, dados) {
    setAuth(dados)
    state.usuario = dados
  },
  REMOVEAUTH (state) {
    cleanAuth()
    state.logado = false
    state.usuario = {}
  },
  ABRECONFIRMASENHA (state, { onConfirm, onClose }) {
    state.confirmaSenha.estado = true
    state.confirmaSenha.onConfirm = onConfirm
    state.confirmaSenha.onClose = onClose
  },
  FECHACONFIRMASENHA (state) {
    state.confirmaSenha.estado = false
    state.confirmaSenha.onConfirm = () => {}
    state.confirmaSenha.onClose = () => {}
  },
  SETACESSOCONFIRMASENHA (state, acesso) {
    state.confirmaSenha.acesso = acesso
  },
  REMOVEACESSOCONFIRMASENHA (state) {
    state.confirmaSenha.acesso = { tela: null, funcionalidade: null }
  },
  SETTOKENCONFIRMASENHA (state, token) {
    state.confirmaSenha.token = token.token || null
  },
  REMOVETOKENCONFIRMASENHA (state) {
    state.confirmaSenha.token = false
  }
}

const actions = {
  async validaLogado ({ state, commit }) {
    if (state.logado) return state
    const auth = getAuth()
    if (!auth || auth.logado === false) throw new Error('Acesso Não Permitido!')
    await commit('SETAUTH', auth)
    return auth
  },
  async login ({ commit }, dados) {
    let retorno = await auth.login(dados)
    commit('SETAUTH', retorno)
    return retorno
  },
  async logout ({ state, commit }) {
    try {
      await auth.logout(state.token.refreshToken)
      await commit('REMOVEAUTH')
    } catch (e) {
      await commit('REMOVEAUTH')
    }
  },
  validaSenhaAsync ({ dispatch, getters }, acesso) {
    return new Promise((resolve, reject) => {
      if (getters.jaConfirmado(acesso)) return resolve()
      dispatch('confirmaSenha', {
        acesso: {
          tela: acesso.tela || null,
          funcionalidade: acesso.funcionalidade || null
        },
        onConfirm: async () => resolve(),
        onClose: async () => reject(new Error('Senha não confirmada'))
      })
    })
  },
  confirmaSenha ({ commit }, { acesso, onConfirm, onClose }) {
    commit('ABRECONFIRMASENHA', { onConfirm, onClose })
    commit('REMOVEACESSOCONFIRMASENHA')
    commit('SETACESSOCONFIRMASENHA', acesso)
    commit('REMOVETOKENCONFIRMASENHA')
  },
  async okConfirmaSenha ({ state, commit }, token) {
    await state.confirmaSenha.onConfirm()
    commit('SETTOKENCONFIRMASENHA', token)
    commit('FECHACONFIRMASENHA')
  },
  async closeConfirmaSenha ({ state, commit }) {
    await state.confirmaSenha.onClose()
    commit('REMOVEACESSOCONFIRMASENHA')
    commit('REMOVETOKENCONFIRMASENHA')
    commit('FECHACONFIRMASENHA')
  }
}

export default { namespaced: true, state, getters, mutations, actions }
